import { Directionality } from "@angular/cdk/bidi";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Optional,
  Output,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTagComponent } from "ng-zorro-antd/tag";
import { UiThemeType } from "../icon/icon.models";

@Component({
  selector: "ui-chip",
  exportAs: "uiChip",
  templateUrl: "./chip.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  host: {
    class: "ui-chip",
    "[class.ui-chip-dissmisable]": `nzMode === "closeable"`,
    "[class.ui-chip-disabled]": `uiDisabled`,
    "[class.ui-chip-icon-bg]": `uiIconBgColor || uiIconFull`,
    "[class.ui-chip-icon-full]": `uiIconFull`,
    "[attr.aria-disabled]": `uiDisabled`,
  },
})
export class UiChipComponent extends NzTagComponent implements AfterViewInit {
  @Input()
  @InputBoolean()
  public set uiCloseable(closeable: boolean) {
    this.nzMode = closeable ? "closeable" : "default";
  }

  @Input()
  @InputBoolean()
  public uiDisabled?: boolean;

  @Input()
  public uiDotColor?: string;

  @Input()
  public uiIconType?: string;

  @Input()
  public uiIconTheme?: UiThemeType = "outline";

  @Input()
  public uiIconBgColor?: string;

  @Input()
  @InputBoolean()
  public uiIconFull?: boolean;

  @Input()
  public uiPicture?: string;

  @Output("uiOnClose")
  public readonly nzOnClose = new EventEmitter<MouseEvent>();

  constructor(cdr: ChangeDetectorRef, private thisRenderer: Renderer2, private thisElementRef: ElementRef<HTMLElement>, @Optional() directionality: Directionality) {
    super(cdr, thisRenderer, thisElementRef, directionality);
  }

  public ngAfterViewInit(): void {
    // if we are inside an anchor, it will contain the focus
    const { nativeElement } = this.thisElementRef;
    if (nativeElement.parentElement?.tagName !== "A") {
      this.thisRenderer.setAttribute(nativeElement, "tabindex", "0");
    }
  }

  @HostListener("keydown.backspace", ["$event"])
  @HostListener("keydown.delete", ["$event"])
  protected handleDelete(event: KeyboardEvent): void {
    if (this.nzMode === "closeable") {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.closeTag(event as any);
    }
  }

  @HostListener("keydown.space", ["$event"])
  protected handleClick(event: KeyboardEvent): void {
    // Prevent page scrolling with 'Space' key
    event.preventDefault();
  }
}
